import React from "react";

const CookieConsent = () => {
  return (
    <div>
      <h4 className="text-lg font-semibold mb-4">Consent to use cookies</h4>
      <p className="mb-6">We will ask for your permission (consent) to place cookies or other similar technologies on your device, except where these are essential for us to provide you with a service that you have requested (e.g., to enable you to log in to our app).</p>
      <p className="mb-6">There is a notice on our home page which describes how we use cookies and requests your consent to place cookies on your device.</p>
    </div>
  );
};

export default CookieConsent;